<template>

  <div class="container">

    <BreadcrumSection :part1="$t('Professorat')"></BreadcrumSection>

    <h1>{{ $t("Professorat") }}</h1>

    <div v-if="totalElements === 0" class="alert alert-danger rounded-0" role="alert">
      {{ $t("No results") }}
    </div>
    <div v-else class="row">

      <div class="col-sm-12 col-md-8" >

        <div class="row">
          <div class="col-sm-12 col-md-8">
            <PaginationTable
                class="container"
                :show-pagination="true"
                v-model:current-page="currentPage"
                v-model:page-size="pageSize"
                :total="totalElements"
                :handle-current-change="handleCurrentChange">
            </PaginationTable>
          </div>

          <div class="col-sm-12 col-md-4">
            <div class="form-control-sm">
              <div class="d-flex align-items-center justify-content-end">
                <label class="form-check-label me-1" for="selectOrderBy">{{ $t("Ordenació") }}:</label>
                <select class="form-select form-select-sm select-auto-width" @change="handleOrderChange(selectedOrder)" v-model="selectedOrder" id="selectOrderBy">
                  <option value="professor_nom_sort asc" selected>{{$t('Nom')}} asc.</option>
                  <option value="professor_nom_sort desc">{{$t('Nom')}} desc.</option>
                  <option value="professor_num_activitats asc">{{$t('Numero activitats')}} asc.</option>
                  <option value="professor_num_activitats desc">{{$t('Numero activitats')}} desc.</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <ul class="list-group list-group-flush mt-1" >
          <li>

            <router-link-locale
                v-for="(professor) in response.professors"
                :key="professor.id"
                :to="{name: 'professor', params: {id: professor.id, listPage: currentPage, listSort: selectedOrder}}"
                class="list-group-item list-group-item-action d-flex align-items-start p-2 w-100"
            >
              <!-- Contenedor de la imagen -->
              <div class="col-md-2 col-xs-12 text-center me-3">
                <img
                    v-if="professor.professor_foto"
                    v-bind:src="professor.professor_foto"
                    alt="user"
                    class="img-thumbnail rounded-0 img-fluid"
                    style="width: 100px; height: 120px; object-fit: cover;"
                >
                <div v-else>
                  <i style="color: gray;" class="fa-regular fa-circle-user fa-4x"></i>
                </div>
              </div>

              <!--img
                  v-else
                  src="@/assets/images/default-profile.png"
                  alt="user silhouette"
                  class="img-thumbnail rounded-0 img-fluid shadow"
                  style="width: 100px; height: 120px; object-fit: cover;"
              -->

              <!-- Contenedor del contenido -->

              <div class="flex-grow-1">

                <div class="d-flex justify-content-between mb-1">
                  <span class="text-blue">{{ professor.professor_nom }}</span>
                  <span class="text-secondary">Activitats<span class="badge rounded-pill badge-upc ms-2">{{ professor.professor_num_activitats }}</span> </span>
                </div>

                <div>
                  <div class="text-secondary mb-1" v-if="professor.professor_departament">
                    <div v-for="departament in professor.professor_departament" :key="departament">
                      {{ $t(departament) }}
                    </div>
                  </div>

                  <div class="mb-1" v-if="professor.professor_centre_docent">
                    <div v-for="centre in professor.professor_centre_docent" :key="centre">
                      {{ $t(centre) }}
                    </div>
                  </div>

                  <div class="color-verd fw-bolder mb-1" v-if="professor.professor_campus">
                    <span v-if="professor.professor_campus !== 'EXTERN'">{{ professor.professor_campus }}</span>
                  </div>
                </div>
              </div>
            </router-link-locale>

          </li>
        </ul>





        <!--ul class="list-group list-group-flush mt-1" >
          <li>
            <router-link-locale
                v-for="(professor) in response.professors"
                :key="professor.id"
                :to="{name: 'professor', params: {id: professor.id}}"
                class="list-group-item list-group-item-action flex-column align-items-start p-2"
            >

              <div class="d-flex justify-content-between mb-1">
                <span class="text-blue">{{ professor.professor_nom }}</span>
                <span class="text-secondary">Activitats<span class="badge rounded-pill badge-upc ms-2">{{ professor.professor_num_activitats }}</span> </span>
              </div>

              <div>
                <div class="text-secondary mb-1" v-if="professor.professor_departament">
                <span v-for="departament in professor.professor_departament" v-bind:key="departament">
                  {{ $t(departament) }}
                </span>
                </div>

                <div class="mb-1" v-if="professor.professor_centre_docent">
                <span v-for="centre in professor.professor_centre_docent" v-bind:key="centre">
                    {{ $t(centre) }}
                </span>
                </div>

                <div class="color-verd fw-bolder mb-1" v-if="professor.professor_campus">
                  <span v-if="professor.professor_campus !== 'EXTERN'">{{ professor.professor_campus }}</span>
                </div>

              </div>
            </router-link-locale>
          </li>
        </ul-->

        <PaginationTable
            class="container mt-3"
            :show-pagination="true"
            v-model:current-page="currentPage"
            v-model:page-size="pageSize"
            :total="totalElements"
            :handle-current-change="handleCurrentChange">
        </PaginationTable>

      </div>

      <div v-if="response.facetes" id="filtres" class="col-sm-12 col-md-4 mt-0">
        <FacetesFilter :data="response.facetes"  @apply-filter="handleApplyFilter" split-index="1"></FacetesFilter>
      </div>
    </div>

  </div>

</template>

<script>

import {computed, onMounted, ref, watch} from "vue";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import PaginationTable from "@/components/PaginationTable.vue";
import store from "@/store";
import FacetesFilter from "@/components/FacetesFilter.vue";
import {useRoute, useRouter} from "vue-router";
import BreadcrumSection from "@/components/sections/BreadcrumbSection.vue";
import {
  createHandleApplyFilter,
  createHandleCurrentChange,
  createHandleOrderChange,
  getProfessors
} from "@/composables/pageFunctions";
import {useQueryWatcher, useSortWatcher} from "@/composables/useWatchers";
import {setMetadata} from "@/composables/metadataFunctions";
import {useI18n} from "vue-i18n";

export default {
  name: "ProfessorsView",
  components: {BreadcrumSection, FacetesFilter, PaginationTable, RouterLinkLocale},

  setup() {

    //const response = ref({ facetes: {} });
    const response = ref({ });

    const query = ref("tipus:professor")
    const initQuery = query.value
    const currentPage = ref(1)
    const totalElements = ref(1)
    const pageSize = computed(() => { return store.getters.pageSize})
    const selectedOrder = ref("professor_nom_sort asc");

    const route = useRoute();
    const router = useRouter();
    const { t } = useI18n();


    onMounted(async () => {
      setMetadata(t('Professorat'))
      await store.dispatch('updateSearchSelected', "Professorat");
      await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-blue.webp') });
      currentPage.value = parseInt(route.params.page) || 1;
      //route.params.sort = selectedOrder.value
      const result = await getProfessors(currentPage.value, store.getters.pageSize, query.value, route.params.sort, route.query)
      response.value = result
      totalElements.value = result.total
    });

    // Función directa que usa variables internas. No es reutilizable. Repite código
    /*const handleCurrentChange = () => {
      router.push({
        name: "professorat",
        params: { page: currentPage.value, sort: route.params.sort },
        query: { ...route.query }
      });
    }*/

    // Lo hago con una función de orden superior (retorna otra función).
    // De esta manera genero dinamicamente una función de manejo de cambios de pagina reutilizable.
    // El caso anterior es solo para utilizar en la página en cuestión (repetiria código)
    const handleCurrentChange = createHandleCurrentChange("professorat", router, route);
    const handleOrderChange = createHandleOrderChange("professorat", router, route, currentPage);

    //Watcher directo. No me permite reutilizarlo
    watch(
        () => route.params.page || 1,
        async (newPage) => {
          currentPage.value = parseInt(newPage) || 1;
          const result = await getProfessors(currentPage.value, store.getters.pageSize, query.value, route.params.sort, route.query);
          response.value = result
          totalElements.value = result.total
        }
    );

    // Configure watchers: for 'page' parameter, and 'sort' parameter. Let to share code
    //usePageWatcher(getProfessors, currentPage, response, totalElements, query, route, store);
    useSortWatcher(getProfessors, currentPage, response, totalElements, query, route, store);
    useQueryWatcher(getProfessors, currentPage, response, totalElements, query, route, store);


    // Apply filer directo. No me permite reutilizar codigo
    /*
    const handleApplyFilter = (newQuery) => {
      if(JSON.stringify(newQuery.query) === "{}"){
        query.value = "tipus:professor"
        const result = getProfessors(currentPage.value, store.getters.pageSize, query.value, route.params.sort);
        response.value = result
        totalElements.value = result.total
        return
      }

      const result2 = Object.keys(newQuery.query)
          .map(key => {
            const values = newQuery.query[key].split(',');
            return values.map(value => `AND ${key}:"${value}"`).join(' ');
          })
          .join(' ');

      query.value = "tipus:professor " + result2.trim();

      const result = getProfessors(currentPage.value, store.getters.pageSize, query.value, route.params.sort);
      response.value = result
      totalElements.value = result.total
    };
    */
    const handleApplyFilter = async (newQuery) => {
      await createHandleApplyFilter({
        newQuery,
        callFunction:getProfessors,
        currentPage,
        query,
        initQuery,
        response,
        totalElements,
        route,
        store
      });
    };


    return {
      response,
      query,

      selectedOrder,
      currentPage,
      totalElements,
      pageSize,

      handleCurrentChange,
      handleApplyFilter,
      handleOrderChange
    }
  }
}

</script>

<style scoped>

</style>
